import { ChangeType, PlanV2 } from "@zapier/checkout/esm/types";
import {
  getChangeLabel,
  getChangeLabelForPlanName,
} from "@zapier/checkout/esm/utils";

/**
 *  Get the dynamic text for headings & buttons based on the type of change
 */
export const getPageText = (changeType: ChangeType, toPlan?: PlanV2) => {
  const changeLabel = getChangeLabel(changeType);
  const heading = getChangeLabelForPlanName(changeType, toPlan?.name ?? "");
  const subheading = `${changeLabel} email`;

  const submitText =
    changeType === "change"
      ? `${changeLabel} account billing`
      : `${changeLabel} my account`;

  return { heading, subheading, submitText };
};
